import React from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as Facebook } from '../../assets/images/facebook1.svg'
import { ReactComponent as Instagram } from '../../assets/images/instagram1.svg'
import { COMPANY_NAME } from '../../utils/apiConfig'


const Footer = () => {
    return (
        <div className='container footer'>
            {/* <div className="footer-form-container">
                <span className='text-left-line'>ENQUIRE US</span>
                <p className="base_heading_2">Love to Hear from You Get in Touch!</p>

                <form action="#" className="contact-form">
                    <div className="form-row">
                        <input type="text" placeholder="Your Name *" required />
                        <input type="email" placeholder="Your Email *" required />
                    </div>
                    <div className="form-row">
                        <input type="text" placeholder="What you are interested *" required />
                        <input type="text" placeholder="Project Budget *" required />
                    </div>
                    <div className="form-row">
                        <textarea placeholder="Message *" required></textarea>
                    </div>
                    <div className="form-row">
                        <button type="submit">Send Message</button>
                    </div>
                </form>

            </div> */}
            <div className="footer-container">
                <div className="footer-col">
                    <Link className='footer_heading' to={"/"}>{ COMPANY_NAME }</Link>
                    <p className='footer_p_tag'>Join us on a journey where creativity knows no bounds and innovation thrives. Contact { COMPANY_NAME } today,</p>
                    <ul className="social-links">
                        <li>
                            <Link to={"/"}>
                                <Facebook />
                            </Link>
                        </li>
                        <li>
                            <Link to={"/"}>
                                <Instagram />
                            </Link>
                        </li>

                    </ul>
                </div>
                <div className="footer-col">
                    <p className='footer_heading'>Usefull Links</p>
                    <ul className="footer-links">
                        <li>
                            <Link to={"/about"}>
                                About Us
                            </Link>
                        </li>
                        <li>
                            <Link to={"/projects"}>
                                Projects
                            </Link>
                        </li>
                        {/* <li>
                            <Link to={"/blogs"}>
                                Blogs
                            </Link>
                        </li> */}
                        <li>
                            <Link to={"/contact"}>
                                Contact Us
                            </Link>
                        </li>
                        <li>
                            <Link to={"/services"}>
                                Our Services
                            </Link>
                        </li>
                        {/* <li>
                            <Link to={"/events"}>
                                Events
                            </Link>
                        </li> */}

                    </ul>
                </div>
                <div className="footer-col">
                    <p className='footer_heading'>Contact Us</p>
                    <ul className="footer-links">
                        <li>
                            <Link to={"mailto:sales@infiniese.com"}>
                                sales@infiniese.com
                            </Link>
                        </li>
                        <li>
                            <Link to={"mailto:support@infiniese.com"}>
                                support@infiniese.com
                            </Link>
                        </li>
                        <li>
                            <Link to={"tel:+919884873316"}>
                                +91 98848 73316
                            </Link>
                        </li>


                    </ul>
                </div>
                <div className="footer-col">
                    <Link className='footer_heading' to={"/"}>Subscribe Us</Link>
                    <p className='footer_p_tag'>Subscribe to our newsletter for future updates. don't worry we don't spam your email address</p>
                </div>
            </div>
            <div className="footer_copyright">
                © Copyright,
                <Link to={"/"}> { COMPANY_NAME } </Link>
                All Rights Reserved
            </div>
        </div>
    )
}

export default Footer